import React from "react";
import { DefaultPageLayout } from "../../../../ui/layouts/DefaultPageLayout";
import GstinVerificationSettings from "../components/GstinVerificationSettings";

export const GstinVerificationSettingsPage: React.FC = () => {
  return (
    <DefaultPageLayout>
      <div className="flex flex-col gap-6 p-6 max-w-4xl">
        <div>
          <h1 className="text-2xl font-bold text-default-font">
            GSTIN Verification
          </h1>
          <p className="text-sm text-neutral-500 mt-1">
            Manage Cashfree integration for GSTIN verification of vendors and
            customers.
          </p>
        </div>
        <GstinVerificationSettings />
      </div>
    </DefaultPageLayout>
  );
};
